import MenuItems from './el-menu-items-collapse.vue';

export default MenuItems;
